/**
 * 调整订单 Modal AdjustOrders
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 *
 *
 **/
import React from "react";
import { Spin,Checkbox, message,Popconfirm,Button} from 'antd';
import Lang from '@components/Lang/Lang';
import AuthBtn from "@components/HoverIcon/AuthBtn";
import EssaModal from '@components/EssaModal/EssaModal';
import {isEmpty,isEmptyObject} from "@utils/utils";
import PicturePreview from '@components/PicturePreview/PicturePreview';
import TakeDeliveryAction from "../../TakeDelivery.action";
import { toFixedWithCommas,} from "@utils/number-util";
import './index.less'
export default class ModalAdjustOrders extends React.Component{
    static defaultProps = {
        deliveryOrderId:"",
        item:{

        },
        flagAdd:true,
        disabled:false, //是否禁用出货，默认否，即可出货
    };
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            loading:false,
            // 表单项
            show:false,
            list:[],
            selectObj:{}
        }
    }
    /**
     * 打开
     * */
    showModal = (flag=true,) => {
        if(flag){
            this.loading(true);
            this.setState({
                show:false,
            })
            TakeDeliveryAction.post({
                deliveryOrderId:this.props.deliveryOrderId
            },"/service/mg/whs/delivery/query-delivery-order-po").then(res=>{
                this.loading(false)
                const resData = res.data;
                const { success,valid, model={},models=[] } = resData;
                if(success&&valid){
                    this.setState({
                        list: models,
                    })
                }
            })
        }
        this.setState({
            visible: flag,
            selectObj:{}
        });
    };
    // 初始化
    loading(flag){
        this.setState({
            loading:flag
        })
    }

    /**
     * 点击确认时 获取表单数据
     ***/
    handleOK(){
        const { selectObj } = this.state;
        const { deliveryOrderId } = this.props;
        let poIds = [];
        for(let key in selectObj){
            if(selectObj[key]){
                poIds.push(key)
            }
        }
        // if(poIds.length>0){
            TakeDeliveryAction.post({
                poIds:poIds,
                deliveryOrderId:deliveryOrderId,
            },"/service/mg/whs/delivery/submit-adjust").then((res)=>{
                const resData =res.data;
                this.loading(false)
                const { success, valid} = resData;
                if(success&&valid){
                    this.showModal(false);
                    this.props.refreshPage()
                    message.success(Lang({id:"CaoZuoChengGong",default:"操作成功"}));
                }else if(resData.message){
                    message.warning(resData.message);
                }else {
                    message.warning(Lang({id:"BaoCunShiBai"}));
                }
            })
        // }else message.warning(Lang({id:"QingXuanZeDingDan", default:"请选择订单"}))

    }
    // 渲染
    renderOne(model={},inx=0,selectObj={}){
        return (<div className={`item flex-item-ver-center${selectObj[model.poId]?" selectItem":""}`} key={"por_"+inx}>
           <Checkbox checked={selectObj[model.poId]} onChange={(e)=>this.onChange(e.target.checked,model.poId)} />
            <div className={"ml_8 flex1"}>
                <div>
                    <p className={"fw_700 black89 font_16 fw_500"}>{model.poCode}</p>
                    <p className={"black66 font_14 flex-item-ver-center"}>
                        {/* 总计 */}
                        {/*箱*/}
                        <span className={"ri-archive-2-fill black33 font_16 mr_2"}></span><span>{model.totalQuantity||'-'}{__getServerLanguage('Xiang')}</span>
                        {/*款*/}
                        {/*<span className="tit margin-left-5">{model.totalCount||'-'}{__getServerLanguage('Kuan')}</span>，*/}
                        {/* 体积 重量*/}
                        <span className={"ri-box-3-fill black33 font_16 ml_20 mr_2"}></span>
                        {/* 待提货 10 时显示 聚合的总体积 */}
                        {/*{toFixedWithCommas(orderStatus==10?model.poTotalVolume:model.totalVolume,3)||'-'} m³*/}
                        {model.totalVolume?toFixedWithCommas(model.totalVolume,3):'-'} m³
                        <span className={"ri-scales-2-fill black33 font_16 ml_20 mr_2"}></span>{toFixedWithCommas(model.totalGrossWeight,3)||'-'} kg
                        {/* 中转城市名称 */}
                        {model.transitCityName?<><span className={"ri-hotel-fill black33 font_16 ml_20 mr_2"}></span>{model.transitCityName}
                            {Lang({id: 'CangKu', default: '仓库'})}
                            </>:null}
                    </p>
                </div>
                {/* 商品图片列表  */}
                {model.poItemSkuFileUrlList&&model.poItemSkuFileUrlList.length>0&&<PicturePreview list={model.poItemSkuFileUrlList}
                                                                                                  styleName={"adjustOrdersPicturePreview"}
                                                                                                  moreNum={6}
                                                                                                  size={80} />}
            </div>
        </div>)
    }
    onChange(checked,id){
        let { selectObj={}} = this.state;
        selectObj[id] = checked;
        this.setState({
            selectObj:selectObj
        })
    }
    componentWillMount(){
    }
    componentDidMount() {
        if(this.props.onRef)this.props.onRef(this);
    };
    componentWillUnmount() {

    }
    render() {
        const { visible, loading, list,selectObj} = this.state;
         return (<>
             <AuthBtn title={Lang({id:"TiaoZhengDingDan",default:"调整订单"})}
                      auth={"Take-Delivery-Adjust-Orders"}// 提货的调整订单权限
                      className={"ml_8"}
                      onClick={()=>this.showModal(true)} />
             <EssaModal title={Lang({id:"TiaoZhengDingDan",default:"调整订单"})}
                        open={visible}
                        closable={false}
                        footer={null}
                        width={660}
                        onCancel={()=>this.showModal(false)}
                        onOk={()=>this.handleOK()} >
                <Spin spinning={loading}>
                    <div className={"adjustOrdersWrap"}>
                        <div className={"color-err font_14"}>
                            {Lang({id:"GouXuanDeDingDanBaoLiu",default:"勾选的订单保留，未勾选订单，需要客户重新预约后提货"})}
                        </div>
                        {list.map((item,inx)=>this.renderOne(item,inx,selectObj))}
                    </div>
                    <div className={"mt_16 text-right"}>
                        <Button className={"mr_8"} onClick={()=>this.showModal(false)}>{Lang({id: "QuXiao",default: "取消"})}</Button>
                        <Popconfirm
                            title={Lang({id: "TiShi",default: "提示"})}
                            description={Lang({id: "QueDingYaoTiaoZhengDingDan",default: "确定要调整订单？"})}
                            onConfirm={()=>this.handleOK()}
                            // onCancel={()=>this.showModal(false)}
                            okText={Lang({id:'queren',default:'确认'})}
                            cancelText={Lang({id:'QuXiao',default:'取消'})}
                            icon={null}
                        >
                            <Button type="primary">{Lang({id: "QueDing",default: "确定"})}</Button>
                        </Popconfirm>
                    </div>
                </Spin>
            </EssaModal>
        </>);
    }
}

